import React from 'react'

const NewsItem = ({ newsItem }) => {
  return (
    <div className="w-full flex items-center borderViewLightPink p-[10px] rounded overflow-hidden">
      <img src={newsItem.image} alt={newsItem.name} className="w-[48px] h-[42px] object-cover" />

      <div className="flex flex-col items-start ml-[8px] flex-1 overflow-hidden">
        <h6 className="w-full text-[#F67443] font-semibold leading-[20px] text-sm mb-1 text-ellipsis whitespace-nowrap overflow-hidden">
          {newsItem.name}
        </h6>

        <p className="text-xs text-[#DE8208]">
          {newsItem.site} • {newsItem.date} • {newsItem.readTime} read
        </p>
      </div>
    </div>
  )
}

export default NewsItem
